import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { CongestionLevel } from "@/types/portCongestion";

interface PortCongestionState {
	/**
	 * Which severity the ranking is showing.
	 *
	 * Persisted, because it is a choice about how someone works rather than a
	 * position on a page: an operator who watches the moderate band wants it back
	 * on the next visit, not the default. `severe` is only ever the first answer.
	 *
	 * The search box deliberately does **not** live here. It is a question about
	 * the list currently on screen, and restoring one days later would leave the
	 * page filtered for a reason nobody remembers.
	 */
	level: CongestionLevel;
}

const initialState: PortCongestionState = {
	level: "severe",
};

const portCongestionSlice = createSlice({
	name: "portCongestion",
	initialState,
	reducers: {
		setCongestionLevel: (state, action: PayloadAction<CongestionLevel>) => {
			state.level = action.payload;
		},
	},
});

export const { setCongestionLevel } = portCongestionSlice.actions;
export default portCongestionSlice.reducer;
